export const createAuthHeader = (token?: string): Record<string, string> => {
  if (!token) return {};
  return {Authorization: `Bearer ${token}`};
};

export const createNoAuthHeader = () => {
  return {Authorization: '', apikey: ''};
};

export default createAuthHeader;
